export default __webpack_public_path__ + "static/media/CH0098.fd3945e9.png";